import { z } from 'zod';

import { makeCitationSchema } from './differential-diagnoses';

// Detail item with text and optional citations. Factory returns fresh
// instances: a Zod instance reused within one schema tree converts to a
// non-top-level $ref, which OpenAI/Anthropic structured outputs reject.
const makePatientOverviewDetailSchema = () =>
  z.object({
    text: z.string(),
    citations: z.array(makeCitationSchema()).optional(),
  });

export const patientOverviewDetailSchema = makePatientOverviewDetailSchema();

export type PatientOverviewDetail = z.infer<typeof patientOverviewDetailSchema>;

// Only supports the new format with citations
export const patientOverviewSchema = z.object({
  details: z.array(makePatientOverviewDetailSchema()),
  reasonForVisit: z.array(makePatientOverviewDetailSchema()),
});

export type PatientOverviewType = z.infer<typeof patientOverviewSchema>;
